interface AvatarProps {
  name: string;
  url?: string | null;
  size?: number;
  online?: boolean;
  className?: string;
}

const PALETTE = ["#5594ff", "#22c55e", "#f59e0b", "#ef4444", "#a855f7", "#06b6d4", "#ec4899", "#14b8a6"];

function colorFor(name: string): string {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) | 0;
  return PALETTE[Math.abs(h) % PALETTE.length];
}

function initials(name: string): string {
  return name.split(/\s+/).slice(0, 2).map((s) => s[0] || "").join("").toUpperCase() || "?";
}

export function Avatar({ name, url, size = 40, online, className = "" }: AvatarProps) {
  const px = `${size}px`;
  const fontSize = `${Math.max(11, Math.floor(size * 0.42))}px`;
  return (
    <div className={`relative inline-flex shrink-0 ${className}`} style={{ width: px, height: px }}>
      {url ? (
        <img src={url} alt={name} className="rounded-full object-cover w-full h-full"
          style={{ boxShadow: "0 1px 0 rgba(255,255,255,0.1) inset" }} />
      ) : (
        <span className="rounded-full grid place-items-center font-semibold text-white w-full h-full"
          style={{ background: `linear-gradient(135deg, ${colorFor(name)}cc, ${colorFor(name)}66)`, fontSize }}>
          {initials(name)}
        </span>
      )}
      {online && (
        <span aria-label="online"
          className="absolute bottom-0 right-0 rounded-full"
          style={{
            width: Math.max(10, size * 0.28),
            height: Math.max(10, size * 0.28),
            background: "#22c55e",
            border: "2px solid rgb(6,8,13)",
          }} />
      )}
    </div>
  );
}
